import { POST_METHOD } from "../../axiosMethod";

export const sendApplyEmail = async (payload) => {
  try {
    const data = await POST_METHOD("/email/apply-to-join", payload);
    return data
  } catch (error) {
    return {
      data:error?.response?.data
    }
  }
};

export const sendContactEmail = async (payload) => {
  try {
    const data = await POST_METHOD("/email/contact-us", payload);
    return data
  } catch (error) {
    return {
      data:error?.response?.data
    }
  }
};